
export enum ConfirmStyle {
  default,
  danger
}
export interface ConfirmOptions {
  title: string
  text: string
  html?: string
  onlyConfirm: boolean
  confirmBtnText: string
  cancelBtnText: string
  confirmFn: Function
  cancelFn: Function
  style: ConfirmStyle
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/confirm/confirm.options.ts